const counters = {};
export const uniqueId = (prefix) => {
    counters[prefix] = (counters[prefix] || 0) + 1;
    return `${prefix}${counters[prefix]}`;
};
//# sourceMappingURL=uniqueId.js.map
// @zapier/design-system@6.3.0 (1dc71580e)
